import Base from './Base';

class Invoice extends Base {

    constructor (token) {
        super(token);
        this.endpoint = 'invoices';
    }

    getLast ( user_id ) {
        return  fetch(this.getUrlEndpoint("get-last/"+user_id),{
            method: 'GET',
            headers: this.headers,
        }).then( response => response.json() )
    }

    getPaginated ( data ) {
        return  fetch(this.getUrlEndpoint("paginated/"),{
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then( response => response.json() )
    }

    fileURL(id, filename){
        return this.getUrlEndpoint("download/file/"+id+'/'+filename+"/")
    }

    downloadPDF(id){
        return this.getUrlEndpoint("download/pdf/"+id)
    }

    downloadXML(id){
        return this.getUrlEndpoint("download/xml/"+id)
    }

    requestCFDI(id){
        
        return fetch(this.getUrlEndpoint("request/cfdi/"+id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
        
    }

    uploadInvoice( data ){

        let formData  = new FormData();  
        console.log(formData.append)
        Object.keys(data).forEach(key=>{
            formData.append(`${key}`,data[key])
            console.log(`${key} : ${data[key]}`);
        });

        console.log(formData)
            return fetch(this.getUrlEndpoint("upload/invoice"),{
                method: 'POST',
                headers: this.fileHeaders,
                body: formData
            }).then( response => response.json() )
    }

    updateInvoice( data ){

        console.log("DATA => ",JSON.stringify(data));
            return fetch(this.getUrlEndpoint("update/invoice"),{
                method: 'POST',
                headers: this.fileHeaders,
                body: JSON.stringify(data)
            }).then( response => response.json() )
    }
    
}

export default Invoice;